import { Field, FieldProps } from 'formik';
import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { NumberField } from 'ui-toolkit/components/NumberField/NumberField';
import { SelectField } from 'ui-toolkit/components/SelectField/SelectField';
import { lenderPaidOptions } from 'components/cdBuilder/utilities/lenderPaidOptions';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';

export interface IOthersFieldsProps {
  baseName: string;
  properties: { [key: string]: boolean };
  readOnly: boolean;
}

export const OthersFields: React.FC<IOthersFieldsProps> = ({ baseName, properties, readOnly }) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const sendingToLabel = isZillowClosingEnabled ? 'Sending to Zillow Closing' : 'Sending to Spruce';

  return (
    <>
      {properties[eFeePropertyNames.OthersPaid] && (
        <div className={'flex-shrink-0 flex-grow  basis-1/6 p-1'}>
          <NumberField
            name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.OthersPaid}`}
            label={'Others Paid'}
            placeholder="$0.00"
            mode="currency"
            decimalScale={2}
            readOnly={readOnly}
          />
        </div>
      )}
      {properties[eFeePropertyNames.SendingToSpruce] && (
        <div className={'flex-shrink-0 flex-grow basis-1/2  p-1'}>
          <Field name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.OthersPaid}`}>
            {({ field }: FieldProps) => (
              <SelectField
                label={sendingToLabel}
                options={lenderPaidOptions(isZillowClosingEnabled)}
                name={`${baseName}.stringFeePropertyValues.${eFeePropertyNames.SendingToSpruce}`}
                isClearable={true}
                isDisabled={
                  readOnly ||
                  !properties[eFeePropertyNames.SendingToSpruce] ||
                  typeof field.value === 'undefined' ||
                  field.value <= 0
                }
              />
            )}
          </Field>
        </div>
      )}
    </>
  );
};
